import Vue from 'vue'
import App from './App.vue'
import store from '@/store/store'

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  store
}).$mount('#resources')

const VueTruncate = require('vue-truncate-filter');
Vue.use(VueTruncate)

Vue.filter('striphtml', function (value) {
  var div = document.createElement("div");
  div.innerHTML = value;
  var text = div.textContent || div.innerText || "";
  return text;
});

// Vue.config.devtools = true
